import { Component, ContentChild, EventEmitter, Input, Output, TemplateRef } from '@angular/core';
import { FormControl } from '@angular/forms';

@Component({
  selector: 'app-select',
  standalone: false,
  templateUrl: './select.component.html',
  styleUrl: './select.component.css'
})
export class SelectComponent<T> {
  @Input() options: T[] = [];
  @Input() placeholder = '';
  @Input() control?: FormControl;
  @Input() suffixIcon?: string;
  @Input() panelClass?: string;
  @Input() displayWith?: (value: T) => string;

  @Output() selectionChange = new EventEmitter<T>();

  @ContentChild(TemplateRef) optionTemplate?: TemplateRef<any>;

  private internalControl = new FormControl();

  get effectiveControl(): FormControl {
    return this.control || this.internalControl;
  }

  onSelectionChange(value: T): void {
    this.selectionChange.emit(value);
  }

  displayFn(value: T): string {
    return this.displayWith ? this.displayWith(value) : String(value);
  }
}
